<template>
  <section class="componentStructure">
    <div class="is-main-content columns is-flex-direction-column">
      <div class="mgt-20px column is-narrow">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3">
                  {{$t('general.previsualisation')}}
                </h1>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <button class="button is-error" @click="retour()">
                {{ $t('general.button.return') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <object
          v-if="url"
          :data="url"
          :name="filename"
          type="application/pdf"
          width="100%"
          height="100%"
        >
          <a :href="url"> {{ filename }} </a>
        </object>
      </div>
    </div>
  </section>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import edition from '@/api/edition';
import messageErreur from '@/services/general/messageErreur';
import { SET_AFFICHE_FOND_NOIR } from '@/store/modules/ui-mutation-type';
import { TYPE_PDF } from '@/configuration/edition/editionConf';

const Ui = createNamespacedHelpers('ui');

export default {
  props: {
    payloadEdition: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      url: '',
      filename: '',
    };
  },
  methods: {
    ...Ui.mapMutations({
      setAfficheFondNoir: SET_AFFICHE_FOND_NOIR,
    }),
    retour() {
      this.setAfficheFondNoir(false);
      this.$emit('closed');
    },
    async edition() {
      const loadingComponent = this.$buefy.loading.open({ container: this.$el });
      try {
        const response = await edition({
          ...this.payloadEdition,
          extension: TYPE_PDF,
        });
        this.url = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        this.filename = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw (e);
      }
    },
  },
  async mounted() {
    this.setAfficheFondNoir(true);
    await this.edition();
  },
};
</script>
